import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { connect } from "react-redux";
import genericAction from "@Actions/generic";

import IkTable from "@Components/IkTable";
import Screen from "@Components/Screen";

import dataHandler from "@Utils/dataHandler";

import WebhookCrud from "./Modals/WebhookCrud";
import ConfirmModal from "@Modals/ConfirmModal";

import styles from "./styles.module.css";

const WebhooksMaster = ({ userName, companyName, currentCompanyId, dispatch }) => {
	const [tableValue, setTableValue] = useState({});
	const [openWebhookCrud, setOpenWebhookCrud] = useState(false);
	const [modalOption, setModalOption] = useState("");
	const [openConfirmModal, setOpenConfirmModal] = useState(false);

	const [filteredItems, setFilteredItems] = useState([]);
	const [filteredCount, setFilteredCount] = useState(null);
	const [filteredPrintData, setFilteredPrintData] = useState([]);
	const defaultParams = { page: 1, orderKey: "id", orderDir: "asc", rows: 15 };

	useEffect(() => {
		(async () => {
			const webhookPromise = dataHandler({
				dispatch,
				url: "webhooks",
				params: defaultParams,
			});
			const [webhookResponse] = await Promise.all([webhookPromise]);
			setFilteredCount(webhookResponse?.count || 0);
			setFilteredItems(webhookResponse?.items || []);
		})();
	}, []);

	const modalData = (name, item) => {
		setTableValue(item);
		setModalOption(name);
		setOpenWebhookCrud(true);
	};

	const handleCloseWebhookCrud = (shouldRefresh) => {
		setOpenWebhookCrud(false);
		setTableValue({});
		setModalOption("");
		if (shouldRefresh) {
			refresh();
		}
	};

	const handleButton = (name, item) => {
		switch (name) {
			case "Watch":
				modalData(name, item);
				break;
			case "Edit":
				modalData(name, item);
				break;
			case "Add":
				modalData(name, {});
				break;
			case "Eraser":
				setOpenConfirmModal(true);
				setTableValue(item);
				break;
			default:
				break;
		}
	};

	const handlerData = async (params, printable) => {
		const data = await dataHandler({ dispatch, url: "webhooks", params });
		if (printable) {
			setFilteredPrintData(data.items || []);
		} else {
			setFilteredItems(data.items || []);
			setFilteredCount(data.count);
		}
	};

	const refresh = async () => {
		const webhookResponse = await dataHandler({
			dispatch,
			url: "webhooks",
			params: defaultParams,
		});
		setFilteredCount(webhookResponse?.count || 0);
		setFilteredItems(webhookResponse?.items || []);
	};

	const apiData = async () => {
		setOpenConfirmModal(false);
		await dispatch(genericAction({ method: "delete", route: `webhooks/${tableValue.id}` }));
		refresh();
	};

	const setRowStyle = (rowData) => {
		if (!rowData.isActive) {
			return { backgroundColor: "#ffcccc" };
		}
		return {};
	};

	return (
		<Screen hasHeader hasSidebar headerTitle="Webhooks">
			<div className={styles.container}>
				<IkTable
					data={filteredItems}
					setRowStyle={setRowStyle}
					disabled={modalOption === "Watch"}
					columns={[
						{
							label: "Acciones",
							action: [
								{ content: "trash", color: "#b43333", onClick: "Eraser", type: "icon" },
								{ content: "edit", color: "#3f7ea3", onClick: "Edit", type: "icon" },
							],
							dataPosition: "center",
							width: 1,
							canFilter: false,
							canSort: false,
						},
						{
							label: "ID",
							key: "id",
							format: "string",
							dataPosition: "center",
							width: 0.5,
						},
						{
							label: "Activo",
							key: "isActive",
							format: "boolean",
							dataPosition: "center",
							width: 1,
						},
						{
							label: "URL Endpoint",
							key: "endpointUrl",
							format: "string",
							dataPosition: "left",
							width: 1,
						},
						{
							label: "API Key",
							key: "jwtToken",
							format: "string",
							dataPosition: "left",
							width: 1,
						},
						{
							label: "Eventos",
							key: "events",
							format: "arrayTruncate",
							width: 1,
						},
						{
							label: "Creador por",
							key: "createdUser.fullName",
							format: "string",
							dataPosition: "center",
							width: 1,
						},
						{
							label: "Fecha creación",
							key: "createdDate",
							format: "dateTime",
							headerPosition: "left",
							dataPosition: "left",
							width: 16,
						},
					]}
					totalRows={filteredCount}
					filteredPrintData={filteredPrintData}
					defaultParams={defaultParams}
					dataHandler={handlerData}
					handlerTable={handleButton}
					mobileCardView
					cardLine1={[
						{ key: "id", label: "ID" },
						{ key: "endpointUrl", label: "Endpoint" },
					]}
					cardLine2={[{ key: "events", label: "Eventos" }]}
					addButton={{ label: "Agregar" }}
					searcher={{ width: "40rem", hideOnMobile: true }}
					print={{ printHeader: { company: companyName, title: "Webhooks", user: userName } }}
				/>
			</div>

			{openWebhookCrud && (
				<WebhookCrud
					onClose={handleCloseWebhookCrud}
					modalOption={modalOption}
					currentCompanyId={currentCompanyId}
					data={{ webhook: tableValue }}
				/>
			)}

			{openConfirmModal && (
				<ConfirmModal
					visible
					icon="exclamation circle"
					header="Confirmar Eliminación"
					buttonLabel="Eliminar"
					content="Está seguro que desea eliminar este Webhook"
					focus={tableValue.endpointUrl}
					onConfirm={() => {
						apiData("Eraser");
					}}
					onDismiss={() => {
						setOpenConfirmModal(false);
					}}
				/>
			)}
		</Screen>
	);
};

function mapStateToProps({ user, company }) {
	return {
		user,
		userName: user.name,
		companyName: company.name,
		currentCompanyId: company.companyId,
	};
}

WebhooksMaster.propTypes = {
	companyName: PropTypes.string,
	userName: PropTypes.string,
	currentCompanyId: PropTypes.number,
	dispatch: PropTypes.func,
};

export default connect(mapStateToProps)(WebhooksMaster);
